import React, { FC, useEffect, useRef } from 'react';
import { IconColorE } from '../../models/enums';
import {
    createBottomSliderSwipeId,
    popBottomSliderSwipe,
    pushBottomSliderSwipe,
} from '../../utils/bottomSliderSwipeStack';
import { clss } from '../../utils/helpers/styleHelpers';
import useSwipe from '../../utils/hooks/useSwipe';
import Icon from '../Icon/Icon';
import Portal from '../Portal/Portal';
import { H3 } from '../Text/Text';

import styles from './bottomSlider.module.scss';

type BottomSliderPropTypes = {
    visible: boolean;
    onClose: () => void;
    title?: string;
    children: any;
};

const BottomSlider: FC<BottomSliderPropTypes> = (props) => {
    const { children, visible, onClose, title } = props;
    const swipeStackIdRef = useRef<number | null>(null);
    if (swipeStackIdRef.current === null) {
        swipeStackIdRef.current = createBottomSliderSwipeId();
    }
    const swipeStackId = swipeStackIdRef.current;

    useEffect(() => {
        if (!visible) {
            return;
        }
        pushBottomSliderSwipe(swipeStackId);
        return () => popBottomSliderSwipe(swipeStackId);
    }, [visible, swipeStackId]);

    const swipe = useSwipe(onClose, {
        enabled: visible,
        stackId: swipeStackId,
    });

    return (
        <Portal id='root'>
            <div className={styles.overlay} style={{ opacity: visible ? .1 : 0, pointerEvents: visible ? 'all' : 'none' }} />
            <div
                className={clss([styles.wrapper, title ? styles.paddings : ''])}
                style={{ bottom: visible ? -2 : '-100vh' }}
                {...swipe}
            >
                <div className={styles.swiper} />
                <Icon
                    name='close'
                    color={IconColorE.DARK_GRAY}
                    className={styles.closeIcon}
                    onClick={onClose}
                />
                {title && (
                    <H3 className={styles.sliderHeader}>{title}</H3>
                )}
                <div className={styles.bodyWrapper}>
                    {children}
                </div>
            </div>
        </Portal>
    );
};

export default BottomSlider;